var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',{attrs:{"config":Object.assign({}, _vm.config, {draggable: false, isStatic: _vm.isStatic})}},[_c('v-arc',{attrs:{"config":Object.assign({}, _vm.elementConfig,
      {innerRadius: parseInt(_vm.innerRadius),
      angle: parseInt(_vm.angle),
      rotationDeg: parseInt(_vm.rotationDegrees),
      fill: _vm.color})}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }